/* eslint-disable class-methods-use-this */
import DemandECE, {
  DemandEntity,
  DemandStatus,
  DemandStatusOptions,
  DemandWDH,
  DemandTranscoAPI,
  DemandTranscoECE,
} from 'utils/__interfaces/MyDemands/DemandEntity'
import { formatDate } from 'utils/Common/date-utils'
import EnumDemandStatus, {
  IconsDemandStatus,
} from 'utils/__enums/MyDemands/demandStatus'

const statusOrder = [
  EnumDemandStatus.ALL.toString(),
  EnumDemandStatus.EN_COURS.toString(),
  EnumDemandStatus.ENVOYE.toString(),
  EnumDemandStatus.EN_ATTENTE_INFO_CLIENT.toString(),
  EnumDemandStatus.PLANIFIE.toString(),
  EnumDemandStatus.TRAITEE.toString(),
  EnumDemandStatus.ANNULE.toString(),
]
class DemandNormalizer {
  normalize(demandList: DemandECE[]): DemandEntity[] {
    return demandList.map((demand) => {
      const address = `${demand.etsPresteAdresse ?? ''} ${
        demand.etsPresteCode ?? ''
      }  ${demand.etsPresteVille ?? ''}`
      const date = formatDate(demand.createdAt, 'DD/MM/YYYY')
      return {
        id: String(demand.id),
        numDemand: demand.numDemand,
        motif: demand.transco.demandMotif.label,
        site: address,
        dateCreation: date,
        statut: demand.statut?.valueECE,
      }
    })
  }

  normalizeWDH(demandList: DemandWDH[]): DemandEntity[] {
    return demandList.map((demand) => {
      const address = `${demand.AdresseSitePrestation ?? ''} 
      ${demand.CodePostalSitePrestation ?? ''}  ${
        demand.VilleSitePrestation ?? ''
      }`
      const date = formatDate(demand.DateCreationExterne, 'DD/MM/YYYY')
      const motif = demand.MotifECE
      const statut = demand.Statut

      return {
        id: String(demand.idDemandeCRM),
        numDemand: demand.NumeroDemande,
        motif,
        site: address,
        dateCreation: date,
        statut,
      }
    })
  }

  normalizeTransco(listeTransco: DemandTranscoAPI[]): DemandTranscoECE[] {
    return listeTransco.map((item) => ({
      id: item.id,
      demandCategoryECE: {
        id: item.demandCategory.id,
        label: item.demandCategory.label,
        value: item.demandCategory.code,
        displayOrder: item.demandCategory.displayOrder,
      },
      demandMotifECE: {
        id: item.demandMotif.id,
        label: item.demandMotif.label,
        value: item.demandMotif.code,
        displayOrder: item.demandMotif.displayOrder,
        formNumber: item.formNumber,
      },
      typeDemand: item.ccapTypeDemand,
      motifDemand: item.ccapMotif,
      detailDemand: item.ccapDetail,
      defaultValue: item.defaultValue,
    }))
  }

  normalizeStatus(
    listStatus: DemandStatus[]
  ): {
    statusOptions: DemandStatusOptions[]
  } {
    const statusOptions = listStatus.map(({ valueECE }) => ({
      label: valueECE,
      value: valueECE,
      icon: IconsDemandStatus[valueECE],
    }))

    statusOptions.push({
      label: EnumDemandStatus.ALL,
      value: 'All',
    })

    // Ordonner les status
    statusOptions.sort(
      (a, b) => statusOrder.indexOf(a.value) - statusOrder.indexOf(b.value)
    )
    return {
      statusOptions,
    }
  }
}

export default new DemandNormalizer()
